var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "el-select",
        {
          staticStyle: { width: "100%" },
          attrs: {
            multiple: "",
            clearable: "",
            filterable: "",
            "allow-create": "",
            placeholder: "请选择",
          },
          on: { change: _vm.handTags },
          model: {
            value: _vm.searchValue,
            callback: function ($$v) {
              _vm.searchValue = $$v
            },
            expression: "searchValue",
          },
        },
        _vm._l(_vm.tagList, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: { label: item.nameEn, value: item.id },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }